import { createSlice } from '@reduxjs/toolkit';
import { deleteCourseClubs } from 'entities/Course/model/services/deleteCourseClubs';
import { getCourseCertificates } from 'entities/Course/model/services/getCourseCertificates';
import { getCourseExperts } from 'entities/Course/model/services/getCourseExperts';
import { getBindCourseExperts } from 'entities/Course/model/services/getBindCourseExperts';
import { getCourseById } from '../services/getCourseById';
import { updateCourse } from '../services/updateCourse';
import { createCourse } from '../services/createCourse';
import { deleteCourse } from '../services/deleteCourse';
import { setCourseClubs } from '../services/setCourseClubs';
import { fetchCourseTests } from '../services/fetchCourseTests';
import { getCoursesList } from '../services/getCoursesList';
import { getCourseDetail } from '../services/getCourseDetail';
var initialState = {
    isLoading: false,
    isSetClubsLoading: false,
    coursesList: {},
    courses: [],
    isShortView: false,
    alphabetFilter: null,
    dateFilter: null,
    activeCourse: {},
    activeCourseSession: null,
    imageSize: 0,
    themeFilter: null,
    certificates: null,
    expertList: null,
    expertBindList: null,
    visibility: 'all',
};
export var courseSlice = createSlice({
    name: 'course',
    initialState: initialState,
    reducers: {
        setCardView: function (state, action) {
            state.isShortView = action.payload === 'short';
        },
        setActiveCourse: function (state, action) {
            state.activeCourse = action.payload;
        },
        setActiveCourseSession: function (state, action) {
            state.activeCourseSession = action.payload;
        },
        updateProjectsList: function (state, action) {
            state.activeCourse.projects = action.payload;
        },
        setAlphabetFilter: function (state, action) {
            state.alphabetFilter = action.payload;
        },
        setDateFilter: function (state, action) {
            state.dateFilter = action.payload;
        },
        setThemeFilter: function (state, action) {
            state.themeFilter = action.payload;
        },
        setVisibility: function (state, action) {
            state.visibility = action.payload;
        },
        setImageSize: function (state, action) {
            state.imageSize = action.payload;
        },
    },
    extraReducers: function (builder) {
        builder
            // getCourseById
            .addCase(getCourseById.pending, function (state) {
            state.error = undefined;
            state.isLoading = true;
        })
            .addCase(getCourseById.fulfilled, function (state, action) {
            state.isLoading = false;
            state.activeCourse = action.payload;
        })
            .addCase(getCourseById.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            // getBindedTests
            .addCase(fetchCourseTests.pending, function (state) {
            state.error = undefined;
            state.isLoading = true;
        })
            .addCase(fetchCourseTests.fulfilled, function (state, action) {
            state.isLoading = false;
            state.activeCourse.tests = action.payload;
        })
            .addCase(fetchCourseTests.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            // setCourseClubs
            .addCase(setCourseClubs.pending, function (state) {
            state.error = undefined;
            state.isSetClubsLoading = true;
        })
            .addCase(setCourseClubs.fulfilled, function (state, action) {
            state.isSetClubsLoading = false;
            state.activeCourse.groups = action.payload.post;
        })
            .addCase(setCourseClubs.rejected, function (state, action) {
            state.isSetClubsLoading = false;
            state.error = action.payload;
        })
            // deleteCourseClubs
            .addCase(deleteCourseClubs.pending, function (state) {
            state.error = undefined;
            // state.isSetClubsLoading = true;
        })
            .addCase(deleteCourseClubs.fulfilled, function (state, action) {
            // state.isSetClubsLoading = false;
            state.activeCourse.groups = action.payload.post;
        })
            .addCase(deleteCourseClubs.rejected, function (state, action) {
            // state.isSetClubsLoading = false;
            state.error = action.payload;
        })
            // updateCourse
            .addCase(updateCourse.pending, function (state) {
            state.error = undefined;
            state.isLoading = true;
        })
            .addCase(updateCourse.fulfilled, function (state, action) {
            state.isLoading = false;
            state.activeCourse = action.payload;
        })
            .addCase(updateCourse.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            .addCase(createCourse.pending, function (state) {
            state.error = undefined;
            state.isLoading = true;
        })
            .addCase(createCourse.fulfilled, function (state, action) {
            state.isLoading = false;
            state.activeCourse = action.payload;
        })
            .addCase(createCourse.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            .addCase(deleteCourse.pending, function (state) {
            state.error = undefined;
            state.isLoading = true;
        })
            .addCase(deleteCourse.fulfilled, function (state) {
            state.isLoading = false;
        })
            .addCase(deleteCourse.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            .addCase(getCourseCertificates.fulfilled, function (state, action) {
            state.certificates = action.payload;
            state.isLoading = false;
        })
            .addCase(getCourseCertificates.pending, function (state) {
            state.isLoading = true;
        })
            .addCase(getCourseCertificates.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            .addCase(getCourseExperts.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            .addCase(getCourseExperts.pending, function (state) {
            state.isLoading = true;
        })
            .addCase(getCourseExperts.fulfilled, function (state, action) {
            state.expertList = action.payload.experts;
            state.isLoading = false;
        })
            .addCase(getBindCourseExperts.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            .addCase(getBindCourseExperts.pending, function (state) {
            state.isLoading = true;
        })
            .addCase(getBindCourseExperts.fulfilled, function (state, action) {
            state.expertBindList = action.payload.experts;
            state.isLoading = false;
        })
            .addCase(getCoursesList.pending, function (state) {
            state.error = undefined;
            state.isLoading = true;
        })
            .addCase(getCoursesList.fulfilled, function (state, action) {
            state.isLoading = false;
            state.courses = action.payload;
        })
            .addCase(getCoursesList.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        })
            .addCase(getCourseDetail.pending, function (state) {
            state.error = undefined;
            state.isLoading = true;
        })
            .addCase(getCourseDetail.fulfilled, function (state, action) {
            state.isLoading = false;
            state.activeCourseSession = action.payload;
        })
            .addCase(getCourseDetail.rejected, function (state, action) {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});
export var courseActions = courseSlice.actions;
export var courseReducer = courseSlice.reducer;
